module.exports = __webpack_public_path__ + "img/interstitial_1.2502c556.jpg";